import React from 'react';
import Heading from './Blocks/Heading';
import Paragraph from './Blocks/Paragraph';
import BulletList from './Blocks/BulletList';
import Table from './Blocks/Table';
import Chart from './Blocks/Chart';
import Quote from './Blocks/Quote';

const BLOCK_COMPONENTS = {
  heading: Heading,
  paragraph: Paragraph,
  bulletList: BulletList,
  table: Table,
  chart: Chart,
  quote: Quote,
};

const BlockRenderer = ({ block, onReferenceClick }) => {
  const BlockComponent = BLOCK_COMPONENTS[block?.type];
  if (!BlockComponent) return null;
  return (
    <div id={`report-block-${block.id}`}>
      <BlockComponent block={block} onReferenceClick={onReferenceClick} />
    </div>
  );
};

export default BlockRenderer;
